import { Col, Form, FormInstance, Input, Row, Select } from "antd";
import { FC, useState } from "react";

interface ViaCepResult {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
};

interface IAddressEditorProps {
  form: FormInstance,
  baseName: string,
};

export const get_cep = async (cep_numbers: string) => {
  const res = await fetch(`/api/cep?cep=${cep_numbers}`);
  const cep_result = await res.json() as ViaCepResult;
  return cep_result;
}

export const AddressEditor: FC<IAddressEditorProps> = ({ baseName, form }) => {
  const [loading, setLoading] = useState(false);

  const handle_cep = async (value: string) => {
    if (!value) return;
    const only_numbers = value.replace(/[.-]/g, '');
    if (only_numbers.length !== 8) return;

    setLoading(true);

    try {
      const cep_result = await get_cep(only_numbers);
      const form_data = form.getFieldsValue();

      form.setFieldValue([baseName, "address"], {
        ...form_data.address,
        zip_code: value,
        state: cep_result?.uf ?? form_data.address.state,
        neighborhood: cep_result?.bairro ?? form_data.address.neighborhood,
        complement: cep_result?.complemento ?? form_data.address.complement,
        city: cep_result?.localidade ?? form_data.address.city,
        address: cep_result?.logradouro ?? form_data.address.address,
        siafi: cep_result?.siafi ?? form_data?.siafi,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="AddressEditor">

      <Row gutter={8}>
        <Col span={4}>
          <Form.Item
            required
            rules={[{ required: true, message: 'Preencha o CEP' }]}
            name={[baseName, "address", 'zip_code']}
            label='CEP'
          >
            <Input onChange={(e) => handle_cep(e.target.value)} />
          </Form.Item>
        </Col>

        <Col span={16}>
          <Form.Item
            required
            rules={[{ required: true, message: 'Preencha o Logradouro' }]}
            name={[baseName, "address", 'address']}
            label='Logradouro'
          >
            <Input disabled={loading} />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            required
            rules={[{ required: true, message: 'Preencha o Número' }]}
            name={[baseName, "address", 'number']}
            label='Número'
          >
            <Input disabled={loading} />
          </Form.Item>
        </Col>

      </Row>

      <Row gutter={8}>
        <Col span={4}>
          <Form.Item
            name={[baseName, "address", 'complement']}
            label='Complemento'
          >
            <Input disabled={loading} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            required
            rules={[{ required: true, message: 'Preencha o Bairro' }]}
            name={[baseName, "address", 'neighborhood']}
            label='Bairro'
          >
            <Input disabled={loading} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            required
            rules={[{ required: true, message: 'Preencha a Cidade' }]}
            name={[baseName, "address", 'city']}
            label='Cidade'
          >
            <Input disabled={loading} />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            required
            rules={[{ required: true, message: 'Preencha o Estado' }]}
            name={[baseName, "address", 'state']}
            label='Estado'
          >
            <Select
              disabled={loading}
              options={[
                { label: "Acre", value: "AC" },
                { label: "Alagoas", value: "AL" },
                { label: "Amapá", value: "AP" },
                { label: "Amazonas", value: "AM" },
                { label: "Bahia", value: "BA" },
                { label: "Ceará", value: "CE" },
                { label: "Distrito Federal", value: "DF" },
                { label: "Espírito Santo", value: "ES" },
                { label: "Goiás", value: "GO" },
                { label: "Maranhão", value: "MA" },
                { label: "Mato Grosso", value: "MT" },
                { label: "Mato Grosso do Sul", value: "MS" },
                { label: "Minas Gerais", value: "MG" },
                { label: "Pará", value: "PA" },
                { label: "Paraíba", value: "PB" },
                { label: "Paraná", value: "PR" },
                { label: "Pernambuco", value: "PE" },
                { label: "Piauí", value: "PI" },
                { label: "Rio de Janeiro", value: "RJ" },
                { label: "Rio Grande do Norte", value: "RN" },
                { label: "Rio Grande do Sul", value: "RS" },
                { label: "Rondônia", value: "RO" },
                { label: "Roraima", value: "RR" },
                { label: "Santa Catarina", value: "SC" },
                { label: "São Paulo", value: "SP" },
                { label: "Sergipe", value: "SE" },
                { label: "Tocantins", value: "TO" },
              ]} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
}
